export const VAT_RATE_VISIBLE_FOOTNOTE_ID = 'vehicle_vat_rate_visible';
export const VAT_RATE_VISIBLE_FOOTNOTE_CONTENT = 'MwSt. ausweisbar';

export interface VatRateVisibleFootnote {
    id: string;
    content: string;
}

export function getVatRateVisibleFootnote(vatRateVisible: boolean | null | undefined): VatRateVisibleFootnote | null {
    if (!vatRateVisible) {
        return null;
    }
    return {
        id: VAT_RATE_VISIBLE_FOOTNOTE_ID,
        content: VAT_RATE_VISIBLE_FOOTNOTE_CONTENT,
    };
}

export function buildPriceWithVatFootnote(formattedPrice: string, vatRateVisible: boolean | null | undefined): string {
    return vatRateVisible ? `${formattedPrice}#f_${VAT_RATE_VISIBLE_FOOTNOTE_ID}#` : formattedPrice;
}

export function parseVatRateVisibleFilterValues(value: unknown): boolean[] {
    const raw = Array.isArray(value) ? value : value === undefined ? [] : [value];
    const booleans = raw.map((entry) => `${entry}` === 'true');
    return [...new Set(booleans)];
}

export function formatVatRateVisibleFilterLabel(value: number | string): string {
    return `${value}` === 'true' ? 'MwSt. ausweisbar' : 'MwSt. nicht ausweisbar';
}
